var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIdLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_3033_13950)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3033_13950",
    x1: -10.7259,
    y1: -6.06897,
    x2: 23.5959,
    y2: -3.42345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0012D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317308,
    stopColor: "#0048CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639423,
    stopColor: "#007EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33D8D3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIdLogo);
export default __webpack_public_path__ + "static/media/user-id-logo.b7311cd55788946977fb43199a060da9.svg";
export { ForwardRef as ReactComponent };